import { Typography, useTheme } from "@mui/material";
import "./Paragraph.css"

export default function Paragraph({ children }: { children: string }) {
  const theme = useTheme();
  return (
    <Typography
      variant="body1"
      align="left"
      color={theme.palette.secondary.contrastText}
      className="paragraph"
      fontSize={20}
    >
      {children}
    </Typography>
  );
}
